const WIDGET_BUTTON_IDS = {
  EDIT_ADDRESS: 'module-edit-address-button',
  EDIT_ABOUT_YOU: 'module-edit-about-you-button',
  GET_QUOTE: 'module-get-quote-button',
  REVIEW_COVERAGE: 'module-review-coverage-button',
};

export const HomesiteConstants = {
  WIDGET_BUTTON_IDS,
};
